import RewardRedeemConfirmationModal from './RewardRedeemConfirmationModal'

export default RewardRedeemConfirmationModal
